import React from 'react';

type Props = {
  children: React.ReactNode;
};

/**
 * span-element with notranslate class attached to it. Telling Google not to translate anything inside.
 */
export const NoTranslateSpan = (props: Props) => {
  return <span className="notranslate">{props.children}</span>;
};
